<template slot="header" slot-scope="scope">
<div>
  <router-link to='/adminuseradd'  class="sidebar-nav-link">
    <el-button  v-if="sso === false"  style="margin-bottom: 17px;" type="primary" icon="el-icon-circle-plus-outline">添加</el-button>
    </router-link>
    <el-table :data="tableData" style="width: 100%" max-height="600">
    <el-table-column  prop="ename" label="名称" min-width="150">
    </el-table-column>
    <el-table-column prop="ecode" label="统一社会信用代码" min-width="120">
    </el-table-column>
      <el-table-column prop="tel" label="手机号码" min-width="120">
    </el-table-column>
    <el-table-column  label="操作">
      <template slot-scope="scope" >
<router-link :to="{path:'/adminuserupdate',query:{pid:scope.row.id,currentPage:currentPage}}"  class="sidebar-nav-link" >
        <el-button type="text" size="small">修改</el-button>
          </router-link>
        <el-button v-if="sso === false" @click="handleDelete(scope.$index,scope.row.id)" type="text" min-width="120" size="small">删除</el-button>
      </template>
    </el-table-column>

  </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @prev-click="handleprevclick"
      @next-click="handlenextclick"
      :current-page="currentPage"
      :page-sizes="[15]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
   <el-dialog title="提示" :visible.sync="delVisible" width="300px" center>
            <div class="del-dialog-cnt">删除不可恢复，是否确定删除？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteRow" >确 定</el-button>
            </span>
        </el-dialog>
</div>

</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl, dataPost } from '@/api/index'
export default {
  name: 'adminuserlist',
  data () {
    return {
      sso: '',
      tableData: [],
      delVisible: false,
      eventIsstate: false,
      searchName: '',
      isState: '',
      delId: '',
      delIndex: '',
      pageSize: 15,
      currentPage: 1,
      total: 0,
      pagenow: 1

    }
  },
  created () {
    var that = this
    console.log(this)
    that.sso = rootPathssb.sso
    dataGetUrl(rootPathssb.rootPath + '/admini/user/list').then(function (response) {
      that.checkSignin(response.data.result)
      console.log(response.data); console.log('bbb')
      that.tableData = response.data.info.list
      that.total = response.data.info.total
      that.pagenow = response.data.info.currentPage
    }).catch(function (error) {
      console.log(error)
      console.log('aaa')
    })
  }, // 页面加载时
  methods: {
    getPageDate (event) {
      let that = this
      dataGetUrl(rootPathssb.rootPath + '/admini/user/list?pagenow=' + this.pagenow).then(function (response) {
        if (response.data.result === 1) {
          that.eventsList = response.data.info.list
          console.log('cg')
        };console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222)
      })
    }, // 获取数据
    handleDelete (index, id) {
      console.log(index)
      console.log(id)
      this.delVisible = true
      this.delId = id
      this.delIndex = index
      console.log(this.delIndex)
    }, // 删除事件弹窗
    deleteRow () {
      this.delVisible = false
      let param = new URLSearchParams()
      param.append('id', this.delId)
      dataPost(rootPathssb.rootPath + '/admini/user/del', param).then(function (response) {
        if (response.data.result === 1) {
          console.log('cg')
        };
      }).catch(function (error) {
        console.log(error)
        console.log('aaa')
      }); this.$router.go(0)
    }, // 删除确定
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val// 获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
    }, // 每页个数变化
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.pagenow = val
      this.getPageDate()
    }, // 第几页
    handleprevclick (val) {
      this.currentPage = val - 1
      this.pagenow = val - 1
      this.getPageDate()
      console.log(this)
    }, // 上一页
    handlenextclick (val) {
      this.currentPage = val + 1
      this.pagenow = val + 1
      this.getPageDate()
    }, // 下一页
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    },
    autSearch () {
      var that = this
      console.log(this)
      dataGetUrl(rootPathssb.rootPath + '/admini/user/list?serchname=' + that.searchName).then(function (response) {
        that.checkSignin(response.data.result)
        console.log(response.data); console.log('bbb')
        that.tableData = response.data.info.list
        that.total = response.data.info.total
        that.pagenow = response.data.info.currentPage
      }).catch(function (error) {
        console.log(error)
        console.log('aaa')
      })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/adminuserlist.vue